module.exports = __webpack_public_path__ + "img/XA.d3951536.svg";